import { EventBus } from '@city-mattress/js-utils/EventBus';
import type { IEventBus } from '@city-mattress/js-utils/EventBus';

export const EVENTS = {
	ITEM_ADDED: 'itemWasAdded',
	ITEM_UPDATED: 'itemWasUpdated',
	ITEM_REMOVED: 'itemWasRemoved',
	DISCOUNT_APPLIED: 'discountWasApplied',
	DISCOUNT_REMOVED: 'discountWasRemoved',
	CART_UPDATED: 'cartWasUpdated',
	REFRESH_CART: 'cartMustRefresh',
	ITEM_PROCESSING: 'itemIsBeingAdded',
	CART_READY: 'cartIsReady',
	ADD_TO_CART: 'addItemsToCart',
	BEFORE_ADD_TO_CART: 'beforeAddItemsToCart',
	AFTER_ADD_TO_CART: 'afterAddItemsToCart',
	ADDED_TO_CART:'itemsWereAddedToCart',
	UPDATE_RENDER: 'cmCart.updateRender',
	UPDATED_RENDER: 'cmCart.updatedRender',
	CART_IS_LOADING: 'cmCart.cartIsLoading'
};

export const CartEventBus: IEventBus = new EventBus();